import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import styles from './ai-text-prompt-box-error.module.scss';

interface AiTextPromptBoxErrorProps {
  invertedColors?: boolean;
  isHidden?: boolean;
  isError?: boolean;
  errorMessage?: string;
  containerClasses?: string;
}

export function AiTextPromptBoxError({isError = false, errorMessage = '', ...props}: AiTextPromptBoxErrorProps): ReactElement<any> | null {
  if (props.isHidden) {
    return null;
  }

  return (
    <div
      className={`flex-row-justify-center ${styles.aiTextsError} ${props.invertedColors ? styles.noBackground : ''} ${isError ? '' : '_hidden'} ${props.containerClasses ?? ''}`}
    >
      <Icon className={`${styles.aiTextsErrorIcon}`} icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_16} type={IconType.DANGER} />
      <div className={styles.aiTextsErrorMessage}>
        <Text dangerouslySetInnerHTML val={errorMessage} size={TextSize.XSMALL} />
      </div>
    </div>
  );
}
